<template>
  <div>
    <div v-if="!isNaN(navigation.positionInList)">
      <v-divider class="ma-0 pa-0"></v-divider>
      <v-row wrap>
        <v-col sm="5">
          <div class="body-2" v-if="navigation.prev">
            <v-btn text @click="navigate(navigation.prev)" data-cy="filteredNav__button--prev">
              <span class="primary--text"> <i class="fas fa-caret-left pr-2 mr-1"></i>Prev</span>
              <span class="och-buttonText--long hidden-sm-and-down ml-1" v-if="navigation.prev">{{
                navigation.prev.title
              }}</span>
            </v-btn>
          </div>
        </v-col>
        <v-col sm="2">
          <div class="mt-2 pt-2 text-sm-center" style="min-height: 45px">
            {{ navigation.positionInList + 1 }} / {{ navigation.listLength }}
            <span v-if="filters.length" data-cy="filteredNav__icon--activeFilters">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="ml-2" color="grey" small v-on="on">fas fa-filter</v-icon>
                </template>
                <span>
                  <div class="body-2">Active Filters ({{ filters.length }})</div>
                  <ul>
                    <li v-for="(filter, index) in filters" :key="index">
                      {{ getFilterLabel(filter) }}
                    </li>
                  </ul>
                </span>
              </v-tooltip>
            </span>
          </div>
        </v-col>
        <v-col sm="5">
          <div class="text-sm-right" v-if="navigation.next">
            <v-btn text @click="navigate(navigation.next)" data-cy="filteredNav__button--next">
              <span class="och-buttonText--long hidden-sm-and-down mr-1" v-if="navigation.next">{{
                navigation.next.title
              }}</span>
              <span class="primary--text">
                Next
                <i class="fas fa-caret-right pl-1"></i>
              </span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <div v-if="isNaN(navigation.positionInList)">
      <v-alert type="info" class="mb-0" data-cy="filteredNav__alert">
        Release note not part of currently filtered list &nbsp; |
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="viewReleaseNotes"
              class="white--text"
              data-cy="filteredNav__alert--button"
              small
              text
              v-on="on"
              >Configure Current Filters</v-btn
            >
          </template>
          <span>
            <div class="body-2">Active Filters ({{ filters.length }})</div>
            <ul>
              <li v-for="(filter, index) in filters" :key="index">
                {{ getFilterLabel(filter) }}
              </li>
            </ul>
          </span>
        </v-tooltip>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { getFilterLabel } from "@/lib/formatters";

export default {
  name: "filteredNavigation",
  components: {},
  computed: {
    packId() {
      return this.$route.params.packId;
    },
    releaseNoteId() {
      return this.$route.params.releaseNoteId;
    },
    user() {
      return this.$store.state.session.user;
    },
  },
  data() {
    return { getFilterLabel };
  },
  methods: {
    navigate(releaseNote) {
      const query = {};
      if (!!this.$route.query.globalSearch) {
        query.globalSearch = this.$route.query.globalSearch;
      }

      const { packId, releaseNoteId } = releaseNote;
      this.$router.push({ name: "testPlanView", params: { packId, releaseNoteId }, query });
    },
    viewReleaseNotes() {
      let name = "testPlanList";

      if (this.user.isOchinUser) {
        name = "releaseNoteList";
      }

      this.$router.push({
        name,
        params: {
          packId: this.packId,
        },
      });
    },
  },
  props: {
    filters: {
      type: Array,
      default: [],
    },
    navigation: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
span.och-buttonText--long {
  display: inline-block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
